import React from "react";
import _ from "lodash";

class Description extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
       const{description,onBlur, onChange, multiLine}=this.props
        const handleOmBlur=(e)=>{
            if(onBlur) {
                onBlur(e)
            }
         
        }
        return (
            <div class={`inputContainer`}>
                {multiLine? <textarea placeholder="Add text here" class={`timelog-description`}  value={description} onChange={onChange} onBlur={handleOmBlur}/>
                : <input type="text" placeholder="Add text here" class={`timelog-description`}  value={description} onChange={onChange} onBlur={handleOmBlur}/>
                }
               
            </div>
        );
    }
}

export default Description;
